export enum PromoCodeType {
  Amount = 'amount',
  Percentage = 'percentage',
}
